export function stickyOrder() {
    var _fixed_button = $('.fixed-mobile');
    var _has_fixed_btn = _fixed_button.hasClass('fixed-mobile');
    var _no_fixed_button = $('.hero-order-inline:not(.fixed-mobile)');

    var body = document.body;
    var docEl = document.documentElement;
    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var clientTop = docEl.clientTop || body.clientTop || 9;

    if(_has_fixed_btn){
        var elem = document.getElementById(_fixed_button.attr('id'));
        var box = elem.getBoundingClientRect();
        var hero_top = box.top + scrollTop - clientTop;
    }

    $(window).on('scroll', function () {
        var hero_scroll = $(window).scrollTop();
        var _is_touch = $('body').hasClass('touch');

        if (hero_scroll >= hero_top) {
            $(".header").addClass("blackBg");
            if (_is_touch) {
                _no_fixed_button.removeClass("visibility-visible").addClass('visibility-hidden');
                if(_has_fixed_btn) {
                    _fixed_button.addClass("hero-order-fixed");
                }
            }
        } else {
            $(".header").removeClass("blackBg");
            if (_is_touch) {
                _no_fixed_button.removeClass('animate-hidden').addClass('visibility-visible');
                if(_has_fixed_btn) {
                    _fixed_button.removeClass("hero-order-fixed");
                }
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/sticky-order.js